import React from 'react';
import { PageHeader } from './index';
import { DesktopPageHeader } from '../../../styled/pageLayout.styles';
import { HeaderTitle } from './styled';
import useScreenSize from '../../../hooks/useScreenSize';
import { useClient } from '../../../hooks/useClient';
import { useGoBack } from '../../../hooks/useGoBack';

interface AdaptivePageHeaderProps {
  title: string;
  type: string;
  isResidencePage?: boolean;
  hasFilters?: boolean;
  pageHeaderDirection?: 'column' | 'row';
}
export const AdaptivePageHeader: React.FC<
  React.PropsWithChildren<AdaptivePageHeaderProps>
> = ({
  title,
  type,
  isResidencePage = false,
  children,
  hasFilters = true,
  pageHeaderDirection = 'column'
}) => {
  const { isSmall } = useScreenSize();
  const isClient = useClient();
  const goBack = useGoBack();

  const showMobileHeader = (isSmall && isClient) || !isClient;
  const showDesktopTitle = (!isSmall && isClient) || !isClient;
  return (
    <>
      {showMobileHeader && (
        <PageHeader
          id="page_header"
          title={title}
          backButtonCypress={`${type}-header-btn-close`}
          titleCypress={`${type}-page-title`}
          onClick={goBack}
          showHeaderBorder={false}
          headerTag="h1"
        />
      )}
      {(hasFilters || (!hasFilters && showDesktopTitle)) && (
        <DesktopPageHeader
          $isResidencePage={isResidencePage}
          $showDesktopTitle={hasFilters}
          $direction={pageHeaderDirection}
        >
          {showDesktopTitle && (
            <HeaderTitle data-cy={`${type}-page-title`} tag="h1">
              {title}
            </HeaderTitle>
          )}
          {children}
        </DesktopPageHeader>
      )}
    </>
  );
};
